module.exports = __webpack_public_path__ + "img/wide.36ae0ae3.jpg";